import { IVendors } from '../business-objects/common';
import GetVendorsInfoResponse from '../business-objects/GetVendorsInfoResponse';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import GetAgenciesInfoResponse from '../business-objects/GetAgenciesInfoResponse';
import * as actionTypes from './actionTypes';
import { AgencyInfo } from '../../Forms/Keywords/business-objects/common';

export const saveVendorInfoToStore = (vendorInfo: GetVendorsInfoResponse) => {
	return {
		type: actionTypes.SAVE_VENDOR_INFO_TO_STORE,
		value: vendorInfo
	};
};

export const saveAgencyInfoToStore = (agencyInfo: GetAgenciesInfoResponse) => {
	return {
		type: actionTypes.SAVE_AGENCY_INFO_TO_STORE,
		value: agencyInfo
	};
};

export const saveUpdatedAgenciesToStore = (agencies: AgencyInfo[]) => {
	return {
		type: actionTypes.UPDATE_AGENCY,
		value: agencies
	};
};
export const loadAgenciesToStore = (agencies: AgencyInfo[]) => {
	return {
		type: actionTypes.LOAD_AGENCIES_TO_STORE,
		value: agencies
	};
};

export const saveUpdatedVendorsToStore = (vendor: IVendors) => {
	return {
		type: actionTypes.UPDATE_VENDOR,
		value: vendor
	};
};

export const saveNewVendorsToStore = (vendor: IVendors) => {
	return {
		type: actionTypes.CREATE_VENDOR,
		value: vendor
	};
};

export const toggleLoading = () => {
	return {
		type: actionTypes.TOGGLE_IS_PROCESSING
	};
};

export const saveNewVendors = (url: string, vendor: IVendors) => {
	return async (dispatch) => {
		try {
			await Api.put(url, vendor).then((res: ApiResponse<any>) => {
				dispatch(saveNewVendorsToStore(res.data));
			});
		} catch (ex) {
			console.log(ex);
		}
	};
};

export const getAllVendors = (url: string) => {
	return async (dispatch, stateInfo) => {
		try {
			if (!stateInfo().Vendors.storeUpdated)
				await Api.post(url).then((res: ApiResponse<any>) => {
					if (res.ok) {
						dispatch(saveVendorInfoToStore(res.data));
					}
				});
		} catch (ex) {
			console.log(ex);
		}
	};
};

export const getAllAgencies = (url: string) => {
	return async (dispatch) => {
		try {
			await Api.get(url).then((res: ApiResponse<any>) => {
				dispatch(loadAgenciesToStore(res.data));
			});
		} catch (ex) {
			console.log(ex);
		}
	};
};

export const saveUpdatedVendors = (url: string, vendor: IVendors) => {
	return async (dispatch) => {
		try {
			await Api.put(url, vendor).then((res: ApiResponse<any>) => {
				dispatch(saveUpdatedVendorsToStore(res.data));
			});
		} catch (ex) {
			console.log(ex);
		}
	};
};

export const saveUpdatedAgencies = (url: string, vendor: number, agencies: number[]) => {
	return async (dispatch) => {
		try {
			await Api.put(url, { vendor, agencies }).then((res: ApiResponse<any>) => {
				dispatch(saveUpdatedAgenciesToStore(res.data));
				return Promise.resolve(res.data);
			});
		} catch (ex) {
			console.log(ex);
			return Promise.reject(ex);
		}
	};
};
